"use client";

import { EffectCards } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
//
import { Button } from "@/components";
import { getImageURL, useSwiperSliderOptions } from "@/lib";

export const PrimePageBenefitSection = ({ data = {}, slug = "download" }) => {
    let { heading, button, benefit_card = [] } = data;

    const {
        nextSlide,
        prevSlide,
        sliderButtons: { hasNext, hasPrev },
        options: imagesSliderOptions,
    } = useSwiperSliderOptions({
        modules: [EffectCards],
        effect: "cards",
        grabCursor: true,
        loop: true,
        direction: "vertical",
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        cardsEffect: {
            slideShadows: false,
        },
        breakpoints: {
             
              320: { 
                direction: "horizontal",
               },
              768: { 
                direction: "vertical",
              },
          }
    });

    if (benefit_card?.length < 6) {
        benefit_card = [...benefit_card, ...benefit_card];
    }

    return (
        <>
            <section className="wp__section">
                <div className="custom-container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-10 col-xxl-8">
                            <div className="section_header text-center">
                                <h2
                                    className="heading fs-48 fw-300"
                                    dangerouslySetInnerHTML={{
                                        __html: heading,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-9 col-xl-8 col-xxl-8">
                            <div className="wp__wrapper">
                                <div className="wp__slider">
                                    <Swiper {...imagesSliderOptions}>
                                        {benefit_card?.map((item, index) => (
                                            <SwiperSlide key={index}>
                                                <div className="benefit_waaree_box">
                                                    <div className="benefit_waaree_box_inr">
                                                        <div className="benefit_waaree_outer_circle">
                                                            <div className="benefit_waaree_inner_circle">
                                                                <img
                                                                    className="img-fluid"
                                                                    src={getImageURL(
                                                                        item
                                                                            ?.icon
                                                                            ?.src
                                                                    )}
                                                                    alt={
                                                                        item
                                                                            ?.icon
                                                                            ?.alt ||
                                                                        ""
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="benefit_waaree_content">
                                                            <h4
                                                                className="fs-36 fw-300"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: item?.title,
                                                                }}
                                                            />

                                                            <div className="content__wrap">
                                                                <p
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item?.description,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="waaree_benefit_right_img">
                                                        <img
                                                            className="img-fluid"
                                                            src={getImageURL(
                                                                item?.image?.src
                                                            )}
                                                            alt={
                                                                item?.image
                                                                    ?.alt || ""
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>

                                <ul className="waaree_benefit__slider_btn list-unstyled">
                                    <li
                                        className={`prev-btn-waaree_benefit ${
                                            hasPrev ? "" : "disable"
                                        }`}
                                    >
                                        <a
                                            href="#!"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                prevSlide();
                                            }}
                                        >
                                            <svg
                                                width={87}
                                                height={87}
                                                viewBox="0 0 87 87"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x={-1}
                                                    y={1}
                                                    width={85}
                                                    height={85}
                                                    rx="42.5"
                                                    transform="matrix(-1 0 0 1 85 0)"
                                                    stroke="#0DB02B"
                                                    strokeWidth={2}
                                                />
                                                <path
                                                    d="M62.9744 42.0003C63.5265 41.9862 63.9855 42.4223 63.9997 42.9744C64.0138 43.5265 63.5777 43.9855 63.0256 43.9997L62.9744 42.0003ZM23.3112 44.725C22.9108 44.3446 22.8946 43.7117 23.275 43.3113L29.4737 36.7863C29.8541 36.3858 30.4871 36.3696 30.8875 36.75C31.2879 37.1304 31.3041 37.7633 30.9237 38.1638L25.4138 43.9637L31.2137 49.4737C31.6142 49.8541 31.6304 50.4871 31.25 50.8875C30.8696 51.2879 30.2367 51.3041 29.8362 50.9237L23.3112 44.725ZM63 43L63.0256 43.9997L24.0256 44.9997L24 44L23.9744 43.0003L62.9744 42.0003L63 43Z"
                                                    fill="#0DB02B"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                    <li
                                        className={`next-btn-waaree_benefit ${
                                            hasNext ? "" : "disable"
                                        }`}
                                    >
                                        <a
                                            href="#!"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                nextSlide();
                                            }}
                                        >
                                            <svg
                                                width={87}
                                                height={87}
                                                viewBox="0 0 87 87"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x={1}
                                                    y={1}
                                                    width={85}
                                                    height={85}
                                                    rx="42.5"
                                                    stroke="#0DB02B"
                                                    strokeWidth={2}
                                                />
                                                <path
                                                    d="M24.0256 42.0003C23.4735 41.9862 23.0145 42.4223 23.0003 42.9744C22.9862 43.5265 23.4223 43.9855 23.9744 43.9997L24.0256 42.0003ZM63.6888 44.725C64.0892 44.3446 64.1054 43.7117 63.725 43.3113L57.5263 36.7863C57.1459 36.3858 56.5129 36.3696 56.1125 36.75C55.7121 37.1304 55.6959 37.7633 56.0763 38.1638L61.5862 43.9637L55.7863 49.4737C55.3858 49.8541 55.3696 50.4871 55.75 50.8875C56.1304 51.2879 56.7633 51.3041 57.1638 50.9237L63.6888 44.725ZM24 43L23.9744 43.9997L62.9744 44.9997L63 44L63.0256 43.0003L24.0256 42.0003L24 43Z"
                                                    fill="#0DB02B"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="btn-group text-center">
                                {button?.title && (
                                    <Button
                                        label={button?.title}
                                        href={button?.url}
                                        target={
                                            button?.open_new_tab === "yes"
                                                ? "_blank"
                                                : undefined
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
